(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hg-faq').forEach(function (root) {
    if (root.dataset.hgFaqInit) return;
    root.dataset.hgFaqInit = 'true';

    var searchInput = root.querySelector('.hg-faq__search');
    var clearBtn = root.querySelector('.hg-faq__clear');
    var emptyMsg = root.querySelector('.hg-faq__empty');
    var emptyTerm = root.querySelector('.hg-faq__empty-term');
    var emptyReset = root.querySelector('.hg-faq__empty-reset');
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-category]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));

    items.forEach(function (item) {
      var btn = item.querySelector('.hg-faq__q');
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    if (!searchInput) return;

    function runSearch() {
      var term = searchInput.value.trim().toLowerCase();
      clearBtn.hidden = term.length === 0;

      if (term === '') {
        items.forEach(function (item) {
          item.hidden = false;
          item.classList.remove('is-open');
          item.querySelector('.hg-faq__q').setAttribute('aria-expanded', 'false');
        });
        categories.forEach(function (c) { c.hidden = false; });
        emptyMsg.hidden = true;
        return;
      }

      var anyVisible = false;

      categories.forEach(function (cat) {
        var catItems = Array.prototype.slice.call(cat.querySelectorAll('[data-item]'));
        var catHasMatch = false;

        catItems.forEach(function (item) {
          var qText = item.querySelector('[data-q-text]').textContent.toLowerCase();
          var aText = item.querySelector('[data-a-text]').textContent.toLowerCase();
          var matches = qText.indexOf(term) !== -1 || aText.indexOf(term) !== -1;

          item.hidden = !matches;

          if (matches) {
            catHasMatch = true;
            anyVisible = true;
            item.classList.add('is-open');
            item.querySelector('.hg-faq__q').setAttribute('aria-expanded', 'true');
          } else {
            item.classList.remove('is-open');
            item.querySelector('.hg-faq__q').setAttribute('aria-expanded', 'false');
          }
        });

        cat.hidden = !catHasMatch;
      });

      emptyMsg.hidden = anyVisible;
      emptyTerm.textContent = searchInput.value.trim();
    }

    searchInput.addEventListener('input', runSearch);

    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      runSearch();
      searchInput.focus();
    });

    if (emptyReset) {
      emptyReset.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = '';
        runSearch();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
